import {TableSettings} from "../../../tableSettings";

export const brokerageTruckingOrderList:TableSettings = {
  tableVersion: 10080,
  overflowX: 'scroll',
  overflowY: 'scroll',
  showNewRowPlaceholder: false,
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [ ]
};

export const brokerageTruckingLoadPlanList:TableSettings={
  tableVersion: 10020,
  overflowX: 'scroll',
  overflowY: 'scroll',
  showNewRowPlaceholder: false,
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [ ]
};

export const brokerageTruckingLocalDOList:TableSettings={
  tableVersion: 10026,
  overflowX: 'scroll',
  overflowY: 'scroll',
  showNewRowPlaceholder: false,
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [ ]
};

export const btLoadPlanDetailInfo:TableSettings = {
  tableVersion: 1006,
  overflowX: 'hidden',
  overflowY: 'scroll',
  showNewRowPlaceholder: true,
  height: '240px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: 'No',
      accessor: 'indicator',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.75,
    },
    {
      Header: 'Origin',
      accessor: 'originPort',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5,
    },
    {
      Header: 'Company',
      accessor: 'originName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15,
    },
    {
      Header: 'City',
      accessor: 'originCityState',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 12.5,
    },
    {
      Header: 'M',
      accessor: 'orderCount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.5,
    },
    {
      Header: 'Destination',
      accessor: 'destPortCount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 28.75,
    },
    {
      Header: 'Departure',
      accessor: 'departure',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.75,
    },
    {
      Header: 'D',
      accessor: 'departed',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.5,
    },
    {
      Header: 'Pkgs',
      accessor: 'totPkgs',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.75,
    },
    {
      Header: 'LBS',
      accessor: 'totLbs',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.5,
    },
  ]
};

export const btLoadPlanOrderInfo:TableSettings = {
  tableVersion: 1009,
  overflowX: 'hidden',
  overflowY: 'scroll',
  showNewRowPlaceholder: true,
  height: '350px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: 'No',
      accessor: 'indicator',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.75,
    },
    {
      Header: 'Dest',
      accessor: 'orderDestPort',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.75,
    },
    {
      Header: 'PRO #',
      accessor: 'orderNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.25,
    },
    {
      Header: 'Origin',
      accessor: 'originName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.25,
    },
    {
      Header: 'Destination',
      accessor: 'destName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.25,
    },
    {
      Header: 'Bill To',
      accessor: 'billToName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.25,
    },
    {
      Header: 'Dest. City',
      accessor: 'destCityState',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10,
    },
    {
      Header: 'Arrival',
      accessor: 'arrival',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.75,
    },
    {
      Header: 'Time',
      accessor: 'arrivalTime',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.25,
    },
    {
      Header: 'A',
      accessor: 'arrived',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.5,
    },
    {
      Header: 'Pkgs',
      accessor: 'pkgsUnit',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.38,
    },
    {
      Header: 'LBS',
      accessor: 'lbs',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.87,
    },
    {
      Header: 'CFT',
      accessor: 'cft',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.87,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.5,
    },
  ]
};

export const btLocalDODetailInfo:TableSettings = {
  tableVersion: 1006,
  overflowX: 'hidden',
  overflowY: 'scroll',
  showNewRowPlaceholder: true,
  height: '240px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: 'No',
      accessor: 'indicator',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.75,
    },
    {
      Header: 'Dest',
      accessor: 'destPort',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.75,
    },
    {
      Header: 'PRO #',
      accessor: 'orderNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 16.25,
    },

    {
      Header: 'Pkgs',
      accessor: 'pkgs',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 12.125,
    },
    {
      Header: 'Unit',
      accessor: 'punit',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 12.125,
    },
    {
      Header: 'LBS',
      accessor: 'lbs',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 12.125,
    },
    {
      Header: 'CFT',
      accessor: 'cft',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 12.125,
    },
    {
      Header: 'KGS',
      accessor: 'kgs',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 12.125,
    },
    {
      Header: 'CBM',
      accessor: 'cbm',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 12.125,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.5,
    },
  ]
};

export const orchidBaroList:TableSettings = {
  tableVersion: 1022,
  overflowX: 'scroll',
  overflowY: 'scroll',
  showNewRowPlaceholder: false,
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'purple',
  alternateRows: true,
  columns: [ ]
};